import {
  LIST_TOOLS_REQUEST,
  LIST_TOOLS_SUCCESS,
  LIST_TOOLS_FAIL,
  RESET_LANGUAGE_REQUEST,
  RESET_LANGUAGE_SUCCESS,
  RESET_LANGUAGE_FAIL,
  RESET_STATUS_BY_ITEMS_REQUEST,
  RESET_STATUS_BY_ITEMS_SUCCESS,
  RESET_STATUS_BY_ITEMS_FAIL,
  UPDATE_HEALTHCARE_REQUEST,
  UPDATE_HEALTHCARE_SUCCESS,
  UPDATE_HEALTHCARE_FAIL,
  UPDATE_EFORM_EXPIRED_LINK_REQUEST,
  UPDATE_EFORM_EXPIRED_LINK_SUCCESS,
  UPDATE_EFORM_EXPIRED_LINK_FAIL
} from '../../constants/tools'

const initalState = {
  toolList: [],
  pageable: {
    page: 1,
    size: 10
  },
  loading: false,
  loadingReset: false,
  loadingResetStatusByItems: false,
  loadingUpdate: false,
  error: ''
}

const toolsReducer = (state = initalState, action) => {
  switch (action.type) {
    case LIST_TOOLS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_TOOLS_SUCCESS:
      return {
        ...state,
        toolList: action.payload,
        pageable: action.pageable,
        loading: false,
        error: null
      }
    case LIST_TOOLS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case RESET_LANGUAGE_REQUEST:
      return {
        ...state,
        loadingReset: true
      }
    case RESET_LANGUAGE_SUCCESS:
      return {
        ...state,
        loadingReset: false,
        error: null
      }
    case RESET_LANGUAGE_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingReset: false
      }
    case RESET_STATUS_BY_ITEMS_REQUEST:
      return {
        ...state,
        loadingResetStatusByItems: true
      }
    case RESET_STATUS_BY_ITEMS_SUCCESS:
      return {
        ...state,
        loadingResetStatusByItems: false,
        error: null
      }
    case RESET_STATUS_BY_ITEMS_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingResetStatusByItems: false
      }
    case UPDATE_HEALTHCARE_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_HEALTHCARE_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        error: null
      }
    case UPDATE_HEALTHCARE_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingUpdate: false
      }
    case UPDATE_EFORM_EXPIRED_LINK_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_EFORM_EXPIRED_LINK_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        error: null
      }
    case UPDATE_EFORM_EXPIRED_LINK_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingUpdate: false
      }
    default:
      return state
  }
}

export default toolsReducer
